import React, { useState } from "react";
import { FaEdit, FaTrash } from "react-icons/fa";
import { useFormik } from "formik";
import { toast } from "react-toastify";
import BaseModal from "../../popups/model";
import { Input } from "../../form";
import { updateParticipantLocation, deleteParticipantLocation } from "../../../service";
import AdminPanelButton from "../../form/button/adminPanelButton";

export default function OrgParticipantLocation({
  location,
  prefilledData,
  getAdminParticipantLocations,
  updatedOrderKey
}) {
  const [editOpen, setEditOpen] = useState(false);
  const [loading, setLoading] = useState(false);

  const submitHandler = async () => {
    setLoading(true);

    try {
      const res = await updateParticipantLocation(prefilledData._id, location._id, {
        ...formik.values
      });
      getAdminParticipantLocations();

      toast.success(res.data);
    } catch (err) {
      console.log(err);
    } finally {
      setLoading(false);
      formik.resetForm();
      setEditOpen(!editOpen);
    }
  };

  const deleteHandler = async () => {
    if (window.confirm("Are you sure you want to delete this location?")) {
      try {
        const res = await deleteParticipantLocation(prefilledData._id, location._id);
        getAdminParticipantLocations();

        toast.success(res.data);
      } catch (err) {
        console.log(err);
      }
    }
  };

  const formik = useFormik({
    initialValues: {
      name_de: location?.name_de || "",
      name_en: location?.name_en || "",
      name_fr: location?.name_fr || "",
      name_it: location?.name_it || ""
    },
    onSubmit: submitHandler
  });

  return (
    <>
      <div className="flex items-center justify-between p-4 bg-white rounded-lg shadow-sm border">
        <div className="flex-1">
          <h3 className="text-lg font-medium text-gray-900">
            {location?.name_en ||
              location?.name_de ||
              location?.name_fr ||
              location?.name_it ||
              "Untitled Location"}
          </h3>
          <div className="mt-1 text-sm text-gray-500">
            <span className="mr-4">DE: {location?.name_de || "N/A"}</span>
            <span className="mr-4">EN: {location?.name_en || "N/A"}</span>
            <span className="mr-4">FR: {location?.name_fr || "N/A"}</span>
            <span>IT: {location?.name_it || "N/A"}</span>
          </div>
        </div>
        <div className="flex items-center space-x-2">
          <button
            onClick={() => setEditOpen(!editOpen)}
            className="p-2 text-blue-600 hover:text-blue-800 transition-colors">
            <FaEdit />
          </button>
          <button
            onClick={deleteHandler}
            className="p-2 text-red-600 hover:text-red-800 transition-colors">
            <FaTrash />
          </button>
        </div>
      </div>

      <BaseModal open={editOpen} setOpen={setEditOpen} title={"Edit Participant Location"}>
        <form onSubmit={formik.handleSubmit}>
          <div className="grid grid-cols-2 gap-2">
            <Input
              label="DE"
              name="name_de"
              formik={formik}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              value={formik?.values["name_de"]}
              error={formik?.errors["name_de"]}
              touched={formik?.touched["name_de"]}
            />
            <Input
              label="EN"
              name="name_en"
              formik={formik}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              value={formik?.values["name_en"]}
              error={formik?.errors["name_en"]}
              touched={formik?.touched["name_en"]}
            />
            <Input
              label="FR"
              name="name_fr"
              formik={formik}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              value={formik?.values["name_fr"]}
              error={formik?.errors["name_fr"]}
              touched={formik?.touched["name_fr"]}
            />
            <Input
              label="IT"
              name="name_it"
              formik={formik}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              value={formik?.values["name_it"]}
              error={formik?.errors["name_it"]}
              touched={formik?.touched["name_it"]}
            />
          </div>

          <div className="mt-5 sm:mt-4 grid grid-cols-2 gap-4">
            <AdminPanelButton
              type="submit"
              isSave={true}
              loading={loading}
              bgColor="#FC9E5A"
              textColor="#FFFFFF"
              color="white"
              onClick={() => {}}>
              update
            </AdminPanelButton>
          </div>
        </form>
      </BaseModal>
    </>
  );
}
